import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EventImageComponent } from './components/event-image/event-image.component'

@NgModule({
  declarations: [EventImageComponent],
  imports: [CommonModule],
  exports: [EventImageComponent],
})
export class SharedModule {}
